export default "__VITE_PUBLIC_ASSET__da660b4d__"